/* WHOSE TODAY IS IT.
 *
 * A gym's day starts at midnight where the GYM is. The browser only knows where the
 * LAPTOP is, and `todayISO()` answers with that - so every relative date in the app
 * was computed against the wrong clock. Recording an anchor at a gym whose day had
 * already turned rendered as "-1d ago", which is how this was found; on a coach in a
 * different timezone from the gym, or simply working late, every "N days ago" on
 * every screen was off by one.
 *
 * The server has known this for months. `/api/auth/session` returns the gym's `today`
 * precisely so the client does not have to guess, and nothing read it.
 *
 * One module-level value rather than a prop threaded through forty components: `fmt`
 * is already a singleton and this is the same shape. It is set once when the session
 * resolves and falls back to the laptop until then, which is correct for the sign-in
 * screen - there is no gym yet to have a day.
 */
import type { ISODate } from '@acrostic/model';
import { todayISO } from '@acrostic/model';

let gymDay: ISODate | null = null;

/** Called once when the session resolves, and again if the gym changes. */
export function setGymToday(d: ISODate | null | undefined): void {
  gymDay = d ?? null;
}

/** The gym's day, or the laptop's until we have been told. */
export function gymToday(): ISODate {
  return gymDay ?? todayISO();
}
